export const HEADER_CELL_STYLES = {
  fontWeight: 600,
  color: "#475569",
};

export const PAPER_STYLES = {
  borderRadius: "16px",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
};

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toISOString().slice(0, 10);
};

const getDisplayName = (user = {}) => {
  const account = user.account || user.user || {};
  const firstName = user.firstName ?? account.firstName ?? account.first_name;
  const lastName = user.lastName ?? account.lastName ?? account.last_name;

  return (
    [firstName, lastName].filter(Boolean).join(" ") ||
    user.name ||
    account.name ||
    "Unknown"
  );
};

const getDisplayEmail = (user = {}) => {
  const account = user.account || user.user || {};
  return user.email ?? account.email ?? "-";
};

const getPlanName = (user = {}) =>
  user.subscription?.plan?.name ??
  user.plan?.name ??
  user.subscription?.plan ??
  user.plan ??
  "Unknown";

const getTrialStartDate = (user = {}) => user.startDate;

const getTrialEndDate = (user = {}) => user.nextChargingDate;

const getDaysRemaining = (endDateValue) => {
  if (!endDateValue) return null;

  const endDate = new Date(endDateValue);
  if (Number.isNaN(endDate.getTime())) return null;

  const diffMs = endDate.getTime() - Date.now();
  return Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
};

const getProgress = (startDateValue, endDateValue) => {
  if (!startDateValue || !endDateValue) return null;

  const startDate = new Date(startDateValue);
  const endDate = new Date(endDateValue);

  if (
    Number.isNaN(startDate.getTime()) ||
    Number.isNaN(endDate.getTime()) ||
    endDate <= startDate
  ) {
    return null;
  }

  const totalMs = endDate.getTime() - startDate.getTime();
  const elapsedMs = Date.now() - startDate.getTime();
  const progress = (elapsedMs / totalMs) * 100;

  return Math.min(100, Math.max(0, Math.round(progress)));
};

export const getStatusColor = (status) => {
  switch (status) {
    case "Active":
      return { bg: "#DCFCE7", color: "#16A34A" };
    case "Expired":
      return { bg: "#FEE2E2", color: "#DC2626" };
    case "Expiring Soon":
      return { bg: "#FEF3C7", color: "#F59E0B" };
    case "Expired":
      return { bg: "#F1F5F9", color: "#64748B" };
    default:
      return { bg: "#DBEAFE", color: "#1F4FFF" };
  }
};

export const buildTrialRow = (user) => {
  const startDate = getTrialStartDate(user);
  const endDate = getTrialEndDate(user);
  const daysRemaining = getDaysRemaining(endDate);
  const progress = getProgress(startDate, endDate);
  const rawStatus =
    user.subscriptionStatus ??
    user.status ??
    user.accountStatus ??
    user.account?.accountStatus ??
    "Unknown";

  let status = rawStatus;
  if (daysRemaining === 0) {
    status = "Expired";
  } else if (daysRemaining !== null && daysRemaining <= 3) {
    status = "Expiring Soon";
  } else if (
    daysRemaining === null &&
    ["inactive", "expired"].includes(`${rawStatus}`.toLowerCase())
  ) {
    status = "Expired";
  } else if (`${rawStatus}`.toLowerCase().includes("trial")) {
    status = "Active";
  }

  return {
    id: user._id ?? user.id ?? getDisplayEmail(user),
    accountId:
      user.account?._id ??
      user.account?.id ??
      user.accountId ??
      user.user?._id ??
      user._id ??
      user.id,
    name: getDisplayName(user),
    email: getDisplayEmail(user),
    plan: getPlanName(user),
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
    progress,
    daysRemaining,
    status,
  };
};
